/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_AInputs */

const en_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event A`)
};

const fr_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement A`)
};

const de_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung A`)
};

const it_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento A`)
};

const ru_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие А`)
};

const es_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento A`)
};

const zh_cn2_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件 A`)
};

const ja_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントA`)
};

const hi_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना ए`)
};

const pt_pt2_event_a = /** @type {(inputs: Event_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento A`)
};

/**
* | output |
* | --- |
* | "Event A" |
*
* @param {Event_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_a = /** @type {((inputs?: Event_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_a(inputs)
	if (locale === "de") return de_event_a(inputs)
	if (locale === "it") return it_event_a(inputs)
	if (locale === "ru") return ru_event_a(inputs)
	if (locale === "es") return es_event_a(inputs)
	if (locale === "zh-CN") return zh_cn2_event_a(inputs)
	if (locale === "ja") return ja_event_a(inputs)
	if (locale === "hi") return hi_event_a(inputs)
	if (locale === "pt-PT") return pt_pt2_event_a(inputs)
	return en_event_a(inputs)
});